import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'
import { showAlert } from '../../../utility/SweetAlert'
import { useTranslation } from 'react-i18next'

const InteractorProductReviewCreate = () => {
  const { t } = useTranslation()
  const reviewCreate = useCallback(
    (payload) => {
      ApiService.jsonRequest('/product-review/create', payload, (response) => {
        if (response.status_code === 200) {
          showAlert({
            icon: 'success',
            message: t('response_message.send_success'),
            timer: 2000,
            redirect: '/order',
          })
        } else {
          showAlert({
            icon: 'warning',
            message: t('response_message.send_failed'),
            timer: 2000,
            reload: true,
          })
        }
      })
    },
    [t],
  )
  return { reviewCreate }
}

export default InteractorProductReviewCreate
